<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <div>
    <ng-select [items]="selOptions"
               [formControl]="formControl"
               [formlyAttributes]="field"
               [placeholder]="field.templateOptions.label"
               [virtualScroll]="true"
               [loading]="loading"
               appendTo="body"
               (scroll)="onScroll($event)"
               (scrollToEnd)="onScrollToEnd()"
               bindLabel="header"
               bindValue="id">
      <ng-template ng-option-tmp let-item="item">
        <span [innerHTML]="item.header" style="white-space: pre"></span>
      </ng-template>
    </ng-select>
  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
